import home from './views/home';
import Invitee from './views/Invitee';
import ErrorPage from './views/account_error';

export default [
  {
    path: '/',
    name: 'home',
    component: home,
    meta: {
      title: '助力领券'
    }
  },
  {
    path: '/invitee',
    name: 'invitee',
    component: Invitee,
    meta: {
      title: '助力领券',
      loginCallback: true
    }
  },
  {
    path: '/play_history',
    name: 'play_history',
    component: () => import('./views/playHistory.vue'),
    meta: {
      title: '活动记录'
    }
  },
  {
    path: '/rule',
    name: 'rule',
    component: () => import('./views/rule.vue'),
    meta: {
      title: '活动规则'
    }
  },
  {
    path: '/my_awards',
    name: 'my_awards',
    component: () => import('./views/my_awards.vue'),
    meta: {
      title: '我的奖励'
    }
  },
  {
    path: '/account_error',
    name: 'account_error',
    component: ErrorPage,
    meta: {
      title: '账号异常'
    }
  }
];
